var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptylist"},[_c('div',{staticClass:"content"},[_c('img',{staticClass:"content-image",attrs:{"src":require("@/assets/global/empty.png")}}),_c('div',{staticClass:"content-text"},[_vm._v("空空如也")])])])
}]

export { render, staticRenderFns }